module.exports = __webpack_public_path__ + "img/logo.b8b4941e.png";